'use client';

import useFrameLoopStore from '@/client/stores/useFrameLoopStore';
import { Preload, View } from '@react-three/drei';
import { Canvas } from '@react-three/fiber';
import React, { useEffect, useRef } from 'react';
import * as THREE from 'three';

export default function Scene({ ...props }) {
  const [mounted, setMounted] = React.useState(false);

  // Everything defined in here will persist between route changes, only children are swapped
  const ref = useRef<HTMLCanvasElement>(null!);
  const { frameLoop } = useFrameLoopStore();

  useEffect(() => setMounted(true), []);
  if (!mounted) return null;

  return (
    <Canvas
      {...props}
      eventSource={document.getElementById('event-source') ?? undefined}
      gl={{
        powerPreference: 'high-performance',
        toneMapping: THREE.AgXToneMapping,
        alpha: true,
        antialias: true,
      }}
      frameloop={frameLoop}
      ref={ref}
    >
      <View.Port />
      <Preload all />
    </Canvas>
  );
}
